import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  workflow: false,
  conditions: false,
  pdfEditor: false,
  collections: false,
  fillSubmission: false,
  formBuilder: false,
  templates: false,
};

export type TutorialName = keyof typeof initialState;

const tutorialSlice = createSlice({
  name: 'tutorial',
  initialState,
  reducers: {
    openTutorial: (state, action: PayloadAction<TutorialName>) => {
      // 先將所有狀態設為 false
      Object.keys(state).forEach((key) => {
        state[key as TutorialName] = false;
      });
      // 再將目標狀態設為 true
      state[action.payload] = true;
    },
    closeTutorial: (state, action: PayloadAction<TutorialName>) => {
      state[action.payload] = false;
    },
    toggleTutorial: (state, action: PayloadAction<TutorialName>) => {
      const newValue = !state[action.payload];
      // 先將所有狀態設為 false
      Object.keys(state).forEach((key) => {
        state[key as TutorialName] = false;
      });
      // 再根據切換結果設定目標狀態
      state[action.payload] = newValue;
    },
  },
});

export const { openTutorial, closeTutorial, toggleTutorial } =
  tutorialSlice.actions;

export default tutorialSlice.reducer;
